export const CarrierConfigToken = 'CarrierConfig';
